import { createEnum } from "@redotech/zod-util/zod-enum";

export enum PackingMode {
  INDIVIDUAL = "individual",
  CASE_PACK = "case_pack",
  PALLET = "pallet",
  WEIGHT = "weight",
}

export const PackingModeSchema = createEnum(PackingMode, {
  enumName: "PackingMode",
});

export const packingMode = [
  "individual",
  "case_pack",
  "pallet",
  "weight",
] as const;

export type PackingModeString = (typeof packingMode)[number];
